/**
 * Formato monetario CLP para el módulo de cotizaciones.
 */
export const formatCLP = (value) => {
	const amount = Number.isFinite(Number(value)) ? Math.round(Number(value)) : 0;
	return new Intl.NumberFormat("es-CL", {
		style: "currency",
		currency: "CLP",
		maximumFractionDigits: 0,
	}).format(amount);
};

export const toPositiveInteger = (value) => {
	const parsed = Math.round(Number(value));
	if (!Number.isFinite(parsed) || parsed < 0) return 0;
	return parsed;
};
